import { createApp, h } from "vue";
import "./assets/scss/index.scss";
import App from "./App.vue";
import CommonComponents from "./components/common/";
import Toast, { PluginOptions } from "vue-toastification";
import { ToastOptionsAndRequiredContent } from "vue-toastification/dist/types/types";
import router from "./router";
import { i18n } from "./locales";
import { createPinia } from "pinia";
import { worker } from "./mocks/browser";
import PrimeVue from "primevue/config";
import "primevue/resources/themes/lara-light-indigo/theme.css";
import "primevue/resources/primevue.min.css";
import "primeicons/primeicons.css";
import "vue-toastification/dist/index.css";
import usePrimeVueComponents from "./composables/usePrimeVueComponents";
import ConfirmationService from "primevue/confirmationservice";
import { VueFire } from "vuefire";
import { initAmplify } from "./services/auth/auth.service";
import { firebaseApp } from "./services/firebase";
import piniaPluginPersistedstate from "pinia-plugin-persistedstate";
import Tooltip from "primevue/tooltip";
import ElementPlus from "element-plus";

const pinia = createPinia();
pinia.use(piniaPluginPersistedstate);
const app = createApp({
  setup() {
    initAmplify(); //Initiating AWS amplify.
  },
  render: () => h(App),
});
CommonComponents.register(app);
usePrimeVueComponents(app);

if (import.meta.env.MODE === "mock") {
  worker.start();
}

const filterBeforeCreate = (
  toast: ToastOptionsAndRequiredContent,
  toasts: ToastOptionsAndRequiredContent[]
) => {
  if (toasts.filter((t) => t.type === toast.type).length !== 0) {
    // Returning false discards the toast
    return false;
  }
  // You can modify the toast if you want
  return toast;
};

const options: PluginOptions = {
  // You can set your default options here
  timeout: 1000,
  transition: "enter",
  filterBeforeCreate: filterBeforeCreate,
};
/*
 * initially used for http response(success and error) handling
 */
app.use(PrimeVue);
app.use(ConfirmationService);
app.use(ElementPlus);
app.use(Toast, options);
app.use(i18n);
app.use(pinia);
app.use(router);
app.use(VueFire, {
  // imported above but could also just be created here
  firebaseApp,
});
app.directive("tooltip", Tooltip);
app.mount("#app");
